import Joi from "joi";

export const triggerTypes = [
  "ON_FINITE_STATE",
  "ON_CREATION",
  "ON_UPDATE",
] as const;
export type TriggerType = (typeof triggerTypes)[number];

export const targetTypes = ["CUSTOM_FIELD", "TAG"] as const;
export type TargetType = (typeof targetTypes)[number];

export interface TicketSystemSyncMapping {
  outputKey: string;
  targetType: TargetType;
  targetValue: string;
}

export interface TicketSystemSyncMappings {
  mappings: TicketSystemSyncMapping[];
}

export interface Enrichment {
  id: string;
  name: string;
  task: string;
  isEnabled: boolean;
  filterRules: any;
  options: string;
  output: any;
  createdAt: string;
  updatedAt: string;
  createdBy?: string;
  trigger: TriggerType;
  sources?: string[];
  copilotBlocks?: { id: string }[];
  skillConnection?: {
    id: string;
    skillId: string;
    isActive: boolean;
    skill: {
      id: string;
      name: string;
    };
  };
  topicIds?: number[];
  ticketSystemSyncEnabled?: boolean;
  ticketSystemSyncMappings?: TicketSystemSyncMappings;
}

export interface EnrichmentOption {
  name: string;
  value: string;
  brief?: string;
}

export interface ExtractionOutputField {
  name: string;
  key: string;
  brief: string;
}

const enrichmentOptionSchema = Joi.array<EnrichmentOption>().items(
  Joi.object({
    name: Joi.string().required(),
    value: Joi.string().required(),
  }).unknown()
);

export function buildEnrichmentOptions(options: string): EnrichmentOption[] {
  try {
    const parsed = JSON.parse(options);
    const { error, value } = enrichmentOptionSchema.validate(parsed);
    if (error || !Array.isArray(value)) {
      // Return an empty array or handle error accordingly
      return [];
    }
    return value as EnrichmentOption[];
  } catch {
    return [];
  }
}
